<div class="layout-topbar">
    <div class="topbar-left">

        <a tabindex="0" class="show-menu-button" type="button" (click)="onMenuButtonClick()">
            <i class="pi pi-bars"></i>
        </a>
        
        <a routerLink="/">
            <img class="mobile-logo" [src]="isDarkTheme() ? '/assets/img/necta_Logo_Gradient_White_Signet.svg' : '/assets/img/necta_Logo_Solid_Black_Signet.svg'"
                alt="logo" />
        </a>
    </div>

    <div class="topbar-right" style="display: flex; align-items: center;">
        <ul class="topbar-menu">
            <li class="right-sidebar-item flex gap-2">
                <p-button
                    *ngIf="isButtonVisible()" [disabled]="!isDirty()" [icon]="'pi pi-save'" label="Speichern" [rounded]="true" styleClass="function-btn" (click)="onSaveButtonClick()">
                </p-button>
                <p-button
                    *ngIf="isCancelButtonVisible()" [disabled]="!isDirty()" [icon]="'pi pi-times'" label="Abbrechen" [rounded]="true" [outlined]="true" (click)="onCancelButtonClick()">
                </p-button>
            </li>
        </ul>
    </div>
</div>